const audioLightbox = {
    triggerBtn: document.querySelectorAll('.js-open-audio'),
    closeBtn: document.querySelectorAll('.js-close-audio'),

    reset(audio, wrapper) {
        audio.pause();
        audio.currentTime = 0;
        wrapper.classList.remove('active');
    },

    close(e) {
        const lightbox = e.target.closest('.js-lightbox-audio');
        const audio = lightbox.querySelector('audio');

        if (audio) {
            audioLightbox.reset(audio, lightbox);
            window.removeEventListener('keydown', audioLightbox.closeEscape);
        }
    },

    open(e) {
        const lightbox = e.target.nextElementSibling;
        const audio = lightbox.querySelector('audio');

        if (audio) {
            lightbox.classList.add('active');
            audio.play();

            window.addEventListener('keydown', audioLightbox.closeEscape);
        }
    },

    init() {
        if (this.triggerBtn.length && this.closeBtn) {
            this.triggerBtn.forEach((el) =>
                el.addEventListener('click', this.open)
            );

            this.closeBtn.forEach((el) => {
                el.addEventListener('click', this.close);
            });
        }
    },

    hideOutSideClick(e) {
        if (e.target.matches('.js-lightbox-audio.active')) {
            const audio = e.target.querySelector('audio');
            audioLightbox.reset(audio, e.target);
            window.removeEventListener('keydown', audioLightbox.closeEscape);
        }
    },

    closeEscape(e) {
        const activeLightbox = document.querySelector(
            '.js-lightbox-audio.active'
        );
        if (e.key === 'Escape' && activeLightbox) {
            const audio = activeLightbox.querySelector('audio');
            audioLightbox.reset(audio, activeLightbox);

            window.removeEventListener('keydown', audioLightbox.closeEscape);
        }
    },
};

export default audioLightbox;
